<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        div.pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-tag') || onLoading('fetch-tag')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-tag') || onLoading('fetch-tag')",
                @click="submit",
            )
                v-loading(loader="save-tag") Save

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Tags
                li.breadcrumb-item.active(v-show="!onLoading('fetch-tag')") {{ tag.name }}
    .padding
        .box
            .box-header.dker
                h3 Update Tag
            .box-divider.m-a-0
            .box-body(v-show="!onLoading('fetch-tag')")
                include tag-form
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    computed: {
        ...mapGetters('tag', ['tag']),
    },

    created() {
        this.getTag(this.$route.params.id);
    },

    methods: {
        ...mapActions('tag', ['setTagAttribute', 'getTag', 'updateTag']),

        async submit() {
            const validate = await this.$validator.validate();
            if (!validate) return;

            try {
                await this.updateTag();
                this.swal({ text: 'Tag successfully created' });
                this.$router.push('/');
            } catch (e) {
                this.swalError({ text: e });
            }
        },
        cancel() {
            this.$router.push('/');
        },
        setParentTag(tagId) {
            this.setTagAttribute({ key: 'parent_id', value: tagId });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/tag/tag-edit.vue